import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog }from "@angular/material/legacy-dialog";
import { Observable, Subject } from "rxjs";
import { StructureSelectionDialogComponent } from "./component/structure-selection-dialog/structure-selection-dialog.component";
import { StructureSelctionFilter, StructureSelection, StructureSelectionContext, StructureSelectionDialogScope } from "../structure-selection.model";




@Injectable({
    providedIn: 'root'
})
export class StructureSelectionService {

    constructor(private dialog: MatDialog) { }

    selectAny(selection: StructureSelection): Observable<any> {
        return this.showDialog(new StructureSelectionContext(StructureSelectionDialogScope.ANY, selection, StructureSelctionFilter.ANY));
    }

    selectStationSetOrStation(selection: StructureSelection): Observable<any> {
        return this.showDialog(new StructureSelectionContext(StructureSelectionDialogScope.STATION_OR_STATION_SET, selection, StructureSelctionFilter.ANY));
    }

    selectStation(selection: StructureSelection): Observable<any> {
        return this.showDialog(new StructureSelectionContext(StructureSelectionDialogScope.STATION, selection, StructureSelctionFilter.ANY));
    }

    selectWaitingArea(selection: StructureSelection): Observable<any> {
        return this.showDialog(new StructureSelectionContext(StructureSelectionDialogScope.STATION, selection, StructureSelctionFilter.WAITING_AREA));
    }

    selectStationSet(selection: StructureSelection): Observable<any> {
        return this.showDialog(new StructureSelectionContext(StructureSelectionDialogScope.STATION_SET, selection, StructureSelctionFilter.ANY));
    }

    selectStationGroupOrStationSet(selection: StructureSelection): Observable<any> {
        return this.showDialog(new StructureSelectionContext(StructureSelectionDialogScope.STATION_SET_OR_STATION_GROUP, selection, StructureSelctionFilter.ANY));
    }

    private showDialog(selectionContext: StructureSelectionContext): Observable<any> {
        return this.dialog.open(StructureSelectionDialogComponent, {
            height: '95%',
            width: '95%',
            maxHeight: '960px',
            maxWidth: '1280px',
            data: selectionContext
        }).afterClosed();
    }
}
